<template>
  <div>
    <leads-add></leads-add>
  </div>
</template>

<script>
import SupportsAdd from './SupportsAdd.vue';

export default {
  components: {
    SupportsAdd,
  },

  data() {
    return {};
  },
};
</script>
